import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthguardService implements CanActivate {
  url = environment.url;
  constructor(private router: Router, private http: HttpClient, private apiService: ApiService) { }

  canActivate() {
    return this.http.get(this.url + '/api/user/get-user').pipe(
      map((res: any) => {
          this.apiService.setUser(res.data);
          return true;
      }, err => {
        this.router.navigate(['/login']);
        return false;
      })
    );
  }

}
